import { Centrifuge } from "centrifuge";
import { WebsocketSubscription, } from "./WebsocketSubscription";
export class WebsocketGateway {
    client;
    onConnectedCallbacks = new Set();
    async connect(options) {
        const { uri, accessToken } = options;
        const newClient = new Centrifuge(uri, {
            token: accessToken,
        });
        await this.connectClient(newClient);
        this.callOnConnectedHandler(newClient);
        this.client = newClient;
    }
    disconnect() {
        if (this.client) {
            this.client.disconnect();
        }
        this.client = undefined;
    }
    subscribe(options) {
        return new WebsocketSubscription(this, options).subscribe();
    }
    onConnected(cb) {
        if (this.client) {
            cb(this.client);
        }
        this.onConnectedCallbacks.add(cb);
        return () => this.onConnectedCallbacks.delete(cb);
    }
    callOnConnectedHandler(client) {
        for (const cb of this.onConnectedCallbacks) {
            cb(client);
        }
    }
    async connectClient(client) {
        const connectPromise = new Promise((res) => {
            client.once("connected", () => {
                res();
            });
        });
        client.connect();
        return connectPromise;
    }
}
export default WebsocketGateway;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV2Vic29ja2V0R2F0ZXdheS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcGkvV2Vic29ja2V0R2F0ZXdheS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBQ3hDLE9BQU8sRUFDTCxxQkFBcUIsR0FHdEIsTUFBTSx5QkFBeUIsQ0FBQztBQVVqQyxNQUFNLE9BQU8sZ0JBQWdCO0lBQ25CLE1BQU0sQ0FBeUI7SUFDdEIsb0JBQW9CLEdBQUcsSUFBSSxHQUFHLEVBQWUsQ0FBQztJQUV4RCxLQUFLLENBQUMsT0FBTyxDQUFDLE9BQWdCO1FBQ25DLE1BQU0sRUFBRSxHQUFHLEVBQUUsV0FBVyxFQUFFLEdBQUcsT0FBTyxDQUFDO1FBRXJDLE1BQU0sU0FBUyxHQUFHLElBQUksVUFBVSxDQUFDLEdBQUcsRUFBRTtZQUNwQyxLQUFLLEVBQUUsV0FBVztTQUNuQixDQUFDLENBQUM7UUFFSCxNQUFNLElBQUksQ0FBQyxhQUFhLENBQUMsU0FBUyxDQUFDLENBQUM7UUFDcEMsSUFBSSxDQUFDLHNCQUFzQixDQUFDLFNBQVMsQ0FBQyxDQUFDO1FBQ3ZDLElBQUksQ0FBQyxNQUFNLEdBQUcsU0FBUyxDQUFDO0lBQzFCLENBQUM7SUFFTSxVQUFVO1FBQ2YsSUFBSSxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUM7WUFDaEIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxVQUFVLEVBQUUsQ0FBQztRQUMzQixDQUFDO1FBQ0QsSUFBSSxDQUFDLE1BQU0sR0FBRyxTQUFTLENBQUM7SUFDMUIsQ0FBQztJQUVNLFNBQVMsQ0FDZCxPQUF3QztRQUV4QyxPQUFPLElBQUkscUJBQXFCLENBQUksSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFDLFNBQVMsRUFBRSxDQUFDO0lBQ2pFLENBQUM7SUFFTSxXQUFXLENBQUMsRUFBZTtRQUNoQyxJQUFJLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQztZQUNoQixFQUFFLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQ2xCLENBQUM7UUFDRCxJQUFJLENBQUMsb0JBQW9CLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxDQUFDO1FBQ2xDLE9BQU8sR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLG9CQUFvQixDQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUNwRCxDQUFDO0lBRU8sc0JBQXNCLENBQUMsTUFBa0I7UUFDL0MsS0FBSyxNQUFNLEVBQUUsSUFBSSxJQUFJLENBQUMsb0JBQW9CLEVBQUUsQ0FBQztZQUMzQyxFQUFFLENBQUMsTUFBTSxDQUFDLENBQUM7UUFDYixDQUFDO0lBQ0gsQ0FBQztJQUVPLEtBQUssQ0FBQyxhQUFhLENBQUMsTUFBa0I7UUFDNUMsTUFBTSxjQUFjLEdBQUcsSUFBSSxPQUFPLENBQU8sQ0FBQyxHQUFHLEVBQUUsRUFBRTtZQUMvQyxNQUFNLENBQUMsSUFBSSxDQUFDLFdBQVcsRUFBRSxHQUFHLEVBQUU7Z0JBQzVCLEdBQUcsRUFBRSxDQUFDO1lBQ1IsQ0FBQyxDQUFDLENBQUM7UUFDTCxDQUFDLENBQUMsQ0FBQztRQUVILE1BQU0sQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUVqQixPQUFPLGNBQWMsQ0FBQztJQUN4QixDQUFDO0NBQ0Y7QUFFRCxlQUFlLGdCQUFnQixDQUFDIn0=